export default [
  //报表
    {
    	path: '/xinbaobiao',
    	name: 'xinbaobiao',
    	component: () => import('@/views/baobiao/index')
    },
    {
    	path: '/xinbaobiao/yunyingbaobiao',
    	name: 'yunyingbaobiao',
    	component: () => import('@/views/baobiao/yunyingbaobiao')
    },
    {
    	path: '/xinbaobiao/yunyingbaobiao2',
    	name: 'yunyingbaobiao2',
    	component: () => import('@/views/baobiao/yunyingbaobiao2')
    },
    {
    	path: '/xinbaobiao/yunyingbaobiao3',
    	name: 'yunyingbaobiao3',
    	component: () => import('@/views/baobiao/yunyingbaobiao3')
    },
    {
    	path: '/xinbaobiao/yunyingbaobiao4',
    	name: 'yunyingbaobiao4',
    	component: () => import('@/views/baobiao/yunyingbaobiao4')
    },
    {
    	path: '/xinbaobiao/yunyingbaobiaot',
    	name: 'yunyingbaobiaot',
    	component: () => import('@/views/baobiao/yunyingbaobiaot')
    },
    //报表相关
    {
    	path: '/baobiao/index',
    	name: 'baobiao_index',
    	component: () => import('@/components/baobiao/index')
    },
    {
    	path: '/baobiao/qudaohuafen',
    	name: 'baobiao_qudaohuafen',
    	component: () => import('@/components/baobiao/qudaohuafen')
    },
    {
    	path: '/baobiao/xiaoshouqudao',
    	name: 'baobiao_xiaoshouqudao',
    	component: () => import('@/components/baobiao/xiaoshouqudao')
    },
    {
    	path: '/baobiao/xiaoshouqudao2',
    	name: 'baobiao_xiaoshouqudao2',
    	component: () => import('@/components/baobiao/xiaoshouqudao2')
    },

    {
    	path: '/baobiao/xiaoshouqudao/xiaoshouqudaogoucheng',
    	name: 'baobiao_xiaoshouqudaogoucheng',
    	component: () => import('@/components/baobiao/xiaoshouqudaogoucheng')
    },
    {
    	path: '/baobiao/xiaoshouqudao2/xiaoshouqudao2goucheng',
    	name: 'baobiao_xiaoshouqudao2goucheng',
    	component: () => import('@/components/baobiao/xiaoshouqudao2goucheng')
    },
    {
    	path: '/baobiao/shangpinfenxi',
    	name: 'baobiao_shangpinfenxi',
    	component: () => import('@/components/baobiao/shangpinfenxi')
    },
    {
    	path: '/baobiao/shangpinfenxi/shangpinfenxidetail',
    	name: 'baobiao_shangpinfenxidetail',
    	component: () => import('@/components/baobiao/shangpinfenxidetail')
    },
    {
    	path: '/baobiao/shangpinfenxi/shangpinfenxigoucheng',
    	name: 'baobiao_shangpinfenxigoucheng',
    	component: () => import('@/components/baobiao/shangpinfenxigoucheng')
    },
    //数据报表
    {
    	path: '/dataExcel/dataReport',
    	name: 'dataReport',
    	component:  () => import('@/components/dataExcel/dataReport'),
    },
    {
    	path: '/dataExcel/stock',
    	name: 'stock',
    	component:   () => import('@/components/dataExcel/stock'),
    },
    {
    	path: '/dataExcel/all_report',
    	name: 'all_report',
    	component:   () => import('@/components/dataExcel/all_report'),
    },
    {
    	path: '/dataExcel/store_report',
    	name: 'store_report',
    	component:   () => import('@/components/dataExcel/store_report'),
    },
    {
    	path: '/dataExcel/distributors_report',
    	name: 'distributors_report',
    	component:   () => import('@/components/dataExcel/distributors_report'),
    },
    {
    	path: '/dataExcel/dataReport/product_report',
    	name: 'product_report',
    	component:   () => import('@/components/dataExcel/product_report'),
    },
    {
    	path: '/dataExcel/store_sale',
    	name: 'store_sale',
    	component:   () => import('@/components/dataExcel/store_sale'),
    },
    {
    	path: '/dataExcel/distributors_sale',
    	name: 'distributors_sale',
    	component:   () => import('@/components/dataExcel/distributors_sale'),
    },
    {
    	path: '/dataExcel/product_sale',
    	name: 'product_sale',
    	component:   () => import('@/components/dataExcel/product_sale'),
    },
    {
    	path: '/dataExcel/waihu',
    	name: 'waihu',
    	component:   () => import('@/components/dataExcel/waihu'),
    },

]



// WEBPACK FOOTER //
// ./src/router/baobiao.js